import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as Actions from 'store/actions'

const Redux = (PassedComponent) => {

	const mapStateToProps = ({ user, navigation, rules }) => {
		return {
			user: user,
			navigation: navigation,
			rules: rules
		}
	}

	const mapDispatchToProps = {
		getBusinessRules: Actions.getBusinessRules,
		deleteBusinessRule: Actions.deleteBusinessRule
	}

	return connect(mapStateToProps, mapDispatchToProps)(
		({ ...props }) =>
			<PassedComponent {...props} />
	)
}

export default Redux